module.exports = __webpack_public_path__ + "static/media/spa-and-salon-chains.3a72ad3e.svg";